var map = {
	"./arrow.svg": 204,
	"./calendar.svg": 2317,
	"./close.svg": 314,
	"./filters.svg": 782,
	"./info.svg": 8741,
	"./kind.svg": 2043,
	"./logo.svg": 1972,
	"./menu-close.svg": 3198,
	"./open.svg": 6981,
	"./person.svg": 9196,
	"./resource.svg": 1367,
	"./stage.svg": 1068,
	"./star.svg": 2711,
	"./triangle.svg": 1834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9566;